export default __webpack_public_path__ + "static/media/design-my-life-blueprint.63e27015.png";